/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface RenewRequestDto { 
    productId: number;
    pricepointId: number;
    mcc?: string;
    mnc?: string;
    entryChannel?: string;
    msisdn?: string;
    largeAccount?: string;
    transactionUUID?: string;
    text?: string;
}
